import { OAuthProviders } from '~/types';
import AppleLogo from '~/assets/img/sns/apple.svg';
import GoogleLogo from '~/assets/img/sns/google.svg';

export type SNSButton = {
  title: OAuthProviders;
  icon: string;
};

export const SNSButtons: SNSButton[] = [
  {
    title: 'Google',
    icon: GoogleLogo,
  },
  {
    title: 'Apple',
    icon: AppleLogo,
  },
];
